import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1505_1013">
        <rect id="Frame" width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1013)">
      <path
        id="Vector"
        d="M12.6094 9.41992L40 3.33398L67.3906 9.41992C68.9141 9.75977 70 11.1113 70 12.6738L70 45.9629C70 52.6504 66.6562 58.8945 61.0938 62.6055L40 76.668L18.9062 62.6055C13.3438 58.8945 10 52.6504 10 45.9629L10 12.6738C10 11.1113 11.0859 9.75977 12.6094 9.41992ZM16.668 15.3477L16.668 45.9629C16.668 50.4219 18.8945 54.584 22.6055 57.0586L40 68.6543L57.3945 57.0586C61.1055 54.584 63.332 50.4219 63.332 45.9629L63.332 15.3477L40 10.1641L16.668 15.3477ZM40 36.668C35.3984 36.668 31.668 32.9355 31.668 28.334C31.668 23.7324 35.3984 20 40 20C44.6016 20 48.332 23.7324 48.332 28.334C48.332 32.9355 44.6016 36.668 40 36.668ZM25.0898 53.334C25.9219 45.834 32.2773 40 40 40C47.7227 40 54.0781 45.834 54.9102 53.334L25.0898 53.334Z"
        fill="#AA4040"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
